import type { IState } from 'shared/store';

export const selectEarlyAccessCounterData = (state: IState) => state.earlyAccessCounter;
